// extracted by mini-css-extract-plugin
module.exports = {"item-list":"ItemListColors_item-list__E4Cm7","item__row":"ItemListColors_item__row__JFacP","item__changeinfo":"ItemListColors_item__changeinfo__3gef0"};